import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/subMenuLinkHeads`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/subMenuLinkHeads`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/subMenuLinkHeads/${id}`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/subMenuLinkHeads/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/subMenuLinkHeads/${id}`, payload);
};

const findByItemCode = (merchantId, itemCode, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/subMenuLinkHeads/${itemCode}`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	findByItemCode,
};
